import { createDraftSafeSelector, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { GlobalState } from '@store'
import { LoadingState, User } from '@types'

interface manageState {
  loadingStatus: LoadingState
  loadingStatus2: LoadingState
  message: string
  result: User[]
  totalCount: number
  result2: User[]
  totalCount2: number
}

const initialState: manageState = {
  loadingStatus: 'NOT_STARTED',
  loadingStatus2: 'NOT_STARTED',
  message: '',
  result: [],
  totalCount: 0,
  result2: [],
  totalCount2: 0
}

export type queryAction = PayloadAction<{ result: []; count: number }>
export type relocateAction = PayloadAction<{ user: User; newParentId: string }>

const manageSlice = createSlice({
  name: 'manage',
  initialState,

  reducers: {
    queryByName: (state, _payload: PayloadAction<string>) => {
      return {
        ...state,
        loadingStatus: 'LOADING'
      }
    },
    queryByNameSuccess: (state, { payload }: queryAction) => {
      return {
        ...state,
        loadingStatus: 'SUCCESS',
        result: payload.result,
        totalCount: payload.count
      }
    },
    queryByNameFailed: (state, action) => {
      return {
        ...state,
        loadingStatus: 'FAILED',
        message: action.payload,
        result: [],
        totalCount: 0
      }
    },
    queryByName2: (state, _payload: PayloadAction<string>) => {
      return {
        ...state,
        loadingStatus2: 'LOADING'
      }
    },
    queryByNameSuccess2: (state, { payload }: queryAction) => {
      return {
        ...state,
        loadingStatus2: 'SUCCESS',
        result2: payload.result,
        totalCount2: payload.count
      }
    },
    queryByNameFailed2: (state, action) => {
      return {
        ...state,
        loadingStatus2: 'FAILED',
        message: action.payload,
        result2: [],
        totalCount2: 0
      }
    },
    relocateUser: (state, _payload: relocateAction) => {
      return {
        ...state,
        loadingStatus: 'LOADING',
        loadingStatus2: 'LOADING'
      }
    },
    relocateUserSuccess: state => {
      return {
        ...state,
        loadingStatus: 'SUCCESS',
        loadingStatus2: 'SUCCESS',
        result: [],
        result2: [],
        totalCount: 0,
        totalCount2: 0
      }
    },
    relocateUserFailed: (state, action) => {
      return {
        ...state,
        loadingStatus: 'FAILED',
        loadingStatus2: 'FAILED',
        message: action.payload
      }
    },
    clearManage: _state => {
      return initialState
    }
  }
})

export const manageLoader = createDraftSafeSelector(
  [
    (state: GlobalState) => state.manage.loadingStatus,
    (state: GlobalState) => state.manage.loadingStatus2,
    (state: GlobalState) => state.manage.message
  ],
  (loadingStatus, loadingStatus2, message) => {
    const isLoading = loadingStatus === 'LOADING'
    const isLoading2 = loadingStatus2 === 'LOADING'
    const isFailed = loadingStatus === 'FAILED'
    const isSuccess = loadingStatus === 'SUCCESS'
    return { isLoading, isLoading2, isFailed, isSuccess, message }
  }
)
export const selectQueryResult = (state: GlobalState) => {
  return {
    result: state.manage.result,
    count: state.manage.totalCount
  }
}
export const selectQueryResult2 = (state: GlobalState) => {
  return {
    result2: state.manage.result2,
    count2: state.manage.totalCount2
  }
}

export const {
  queryByName,
  queryByNameSuccess,
  queryByNameFailed,
  queryByName2,
  queryByNameSuccess2,
  queryByNameFailed2,
  relocateUser,
  relocateUserSuccess,
  relocateUserFailed,
  clearManage
} = manageSlice.actions
export default manageSlice.reducer
